import React from 'react';
import Hero from './components/contact/Hero';
import Main from './components/contact/Main';

const ContactUs = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default ContactUs;